'use client';

import React from 'react';
import { Disclosure } from '@headlessui/react';
import { ChevronUpIcon } from '@heroicons/react/24/solid';
import { StaggerContainer, StaggerItem } from '@/components/ui/motion';

const faqs = [
    {
        question: "How does the adoption process work?",
        answer: "Our adoption process is designed to ensure the best match between pets and families. It typically involves submitting an application, a brief interview, meeting the pet, and a home visit. Once approved, you can complete the adoption paperwork and bring your new family member home."
    },
    {
        question: "What are the adoption fees?",
        answer: "Adoption fees vary depending on the animal's species, age, and medical needs. These fees help cover the cost of vaccinations, microchipping, spaying/neutering, and other veterinary care. Specific fees are listed on each pet's profile."
    },
    {
        question: "Do you have puppies or kittens?",
        answer: "Yes, we often have puppies and kittens available for adoption! However, they tend to find homes quickly. We recommend checking our 'Find Your Match' page regularly and submitting an application to be pre-approved."
    },
    {
        question: "Can I return a pet if it doesn't work out?",
        answer: "We understand that sometimes things don't go as planned. If you cannot keep an adopted pet, you are contractually required to return them to us. We will work with you to ensure a smooth transition for the animal."
    },
    {
        question: "Do you adopt out of state?",
        answer: "We consider out-of-state adoptions on a case-by-case basis. Please note that adopters are typically responsible for transportation and may need to visit our facility in person for a meet-and-greet."
    },
    {
        question: "How can I volunteer?",
        answer: "We love volunteers! You can fill out a volunteer application on our website. Opportunities include walking dogs, socializing cats, helping at events, and administrative support."
    }
];

export default function FAQAccordion() {
    return (
        <StaggerContainer className="space-y-4">
            {faqs.map((faq, index) => (
                <StaggerItem key={index}>
                    <Disclosure as="div" className="bg-white rounded-xl shadow-sm border border-gray-200 overflow-hidden">
                        {({ open }) => (
                            <>
                                <Disclosure.Button className="flex justify-between w-full px-6 py-4 text-left text-gray-900 font-medium hover:bg-gray-50 focus:outline-none focus:bg-gray-50 transition-colors">
                                    <span className="text-lg">{faq.question}</span>
                                    <ChevronUpIcon
                                        className={`${open ? 'transform rotate-180' : ''
                                            } w-5 h-5 text-gray-500 transition-transform duration-200`}
                                    />
                                </Disclosure.Button>
                                <Disclosure.Panel className="px-6 pb-4 pt-2 text-gray-600 leading-relaxed border-t border-gray-100">
                                    {faq.answer}
                                </Disclosure.Panel>
                            </>
                        )}
                    </Disclosure>
                </StaggerItem>
            ))}
        </StaggerContainer>
    );
}
